import { Button } from "@/components/ui/button";
import { PageHeader, StatStrip } from "@/components/ui/page-header";
import { Icon } from "@/lib/icons";
import { cn } from "@/lib/utils";

interface ExcelFilesHeaderProps {
  title: string;
  description: string;
  totalCount: number;
  pendingCount: number;
  approvedCount: number;
  totalLabel: string;
  pendingLabel: string;
  approvedLabel: string;
  importLabel: string;
  refreshLabel: string;
  isLoading: boolean;
  onImport: () => void;
  onRefresh: () => void;
}

export function ExcelFilesHeader({
  title,
  description,
  totalCount,
  pendingCount,
  approvedCount,
  totalLabel,
  pendingLabel,
  approvedLabel,
  importLabel,
  refreshLabel,
  isLoading,
  onImport,
  onRefresh,
}: ExcelFilesHeaderProps) {
  return (
    <PageHeader
      level="section"
      title={title}
      description={description}
      actions={
        <>
          <Button variant="outline" size="sm" disabled={isLoading} onClick={onRefresh}>
            <Icon name="refreshCw" className={cn(isLoading && "animate-spin")} />
            {refreshLabel}
          </Button>
          <Button size="sm" onClick={onImport}>
            <Icon name="upload" />
            {importLabel}
          </Button>
        </>
      }
    >
      <StatStrip
        items={[
          { label: totalLabel, value: `${totalCount}` },
          { label: pendingLabel, value: `${pendingCount}`, tone: "attention" },
          { label: approvedLabel, value: `${approvedCount}` },
        ]}
      />
    </PageHeader>
  );
}
